export default {
  form: {
    preparation_time: {
      label: 'Inserisci tempo personalizzato (minuti):',
      placeholder: 'Inserisci minuti',
    },
  },
  buttons: {
    custom: 'Personalizzato',
  },
  feedback: {
    preparation_time_required: 'Il tempo di preparazione deve essere superiore a 0 minuti',
    min_preparation_time: 'Minimo {{minutes}} minuti come tempo di preparazione per consegna esterna',
    max_preparation_time: 'Massimo {{minutes}} minuti come tempo di preparazione',
  },
};
